import React from "react";
import { Modal, Button } from "react-bootstrap";

function ImageGalleryModal({ show, onHide, images = [], index = 0 }) {
  const [current, setCurrent] = React.useState(index);

  React.useEffect(() => {
    setCurrent(index);
  }, [index]);

  const prev = () => setCurrent((c) => (c > 0 ? c - 1 : images.length - 1));
  const next = () => setCurrent((c) => (c < images.length - 1 ? c + 1 : 0));

  if (!images || images.length === 0) return null;

  return (
    <Modal show={show} onHide={onHide} centered size="lg" backdrop="static">
      <Modal.Header closeButton>
        <Modal.Title>
          Image {current + 1} / {images.length}
        </Modal.Title>
      </Modal.Header>
      <Modal.Body className="text-center">
        <img
          src={images[current]}
          alt=""
          style={{
            maxWidth: "100%",
            maxHeight: "70vh",
            objectFit: "contain",
            borderRadius: "8px",
          }}
        />
      </Modal.Body>
      <Modal.Footer className="d-flex justify-content-between">
        <Button variant="secondary" onClick={prev}>
          ◀ Prev
        </Button>
        <Button variant="primary" onClick={next}>
          Next ▶
        </Button>
      </Modal.Footer>
    </Modal>
  );
}

export default ImageGalleryModal;
